import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const gridStyle = recipe({
  base: {},
  variants: {
    variant: {
      threeColumn: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.s,
        ...responsiveContainer({
          500: {
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: theme.spacings.m,
          },
          800: {
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: theme.spacings.l,
          },
        }),
      },
    },
  },
  defaultVariants: {
    variant: "threeColumn",
  },
});

export const carouselStyle = style({
  vars: {
    "--carousel-child-width": rem(300),
    "--carousel-child-max-width": "80vw",
  },
});
